import Helpers from './base/Helpers';

import {
	Entities,
	Exceptions,
	Models,
	Requests,
	Resources,
	Responses,
	Services,
} from './index';

declare global {
	interface Window {
		Entities: any;
		Exceptions: any;
		Models: any;
		Requests: any;
		Resources: any;
		Responses: any;
		Services: any;
		UI: any;
	}
}

if (Helpers.checkIsBrowser()) {
	window.Entities = Entities;
	window.Exceptions = Exceptions;
	window.Models = Models;
	window.Requests = Requests;
	window.Resources = Resources;
	window.Responses = Responses;
	window.Services = Services;
}
